import { useSelector } from 'react-redux';
import uniqueRandomArray from 'unique-random-array';

export const useCreateField = (isForComputer) => {

    const isComputerFieldExist = useSelector(state => state.computer.field.length);
    const isPlayerFieldExist = useSelector(state => state.player.field.length);

    if (isComputerFieldExist && isPlayerFieldExist) return {};

    const allShips = [];

    const createEmptyField = () => {
        return Array.apply(null, Array(100)).map((_, index) => {
            const field = {
                id: toXY(index),
                target: false,
                visual: 'blank'
            };
            if (isForComputer) {
                field.killed = false;
            }
            return field;
        });
    }

    const toXY = number => number < 10 ? '0' + number : String(number);

    const isCellsArroundAvailable = (id, field) => {

        id = typeof id === 'number' ? toXY(id) : id;

        const x = +id[0], y = +id[1];

        const coords = [
            '' + (x - 1) + (y - 1),
            '' + x + (y - 1),
            '' + (x + 1) + (y - 1),
            '' + (x - 1) + y,
            '' + (x + 1) + y,
            '' + (x - 1) + (y + 1),
            '' + x + (y + 1),
            '' + (x + 1) + (y + 1),
        ];

        return coords
            .filter(item => +item >= 0 && +item <= 99)
            .map(item => field[+item].target)
            .every(item => item === false);
    }

    const createShip = (field, decks) => {

        const randomCell = uniqueRandomArray(field.filter(item => item.target === false));
        const cellId = randomCell().id;

        if (!isCellsArroundAvailable(+cellId, field)) {
            return createShip(field, decks);
        }

        if (decks === 1) {
            field[+cellId].target = true;
            allShips.push([cellId]);
            return field;
        }

        const y = cellId[1],
            x = cellId[0],
            horizontalMoving = 1,
            verticalMoving = 10;
        
        const directions = {
            left: y - (decks - 1) >= 0 && isCellsArroundAvailable(cellId - horizontalMoving * (decks - 1), field),
            top: x - (decks - 1) >= 0 && isCellsArroundAvailable(cellId - verticalMoving * (decks - 1), field),
            right: 9 - y - (decks - 1) >= 0 && isCellsArroundAvailable(+cellId + horizontalMoving * (decks - 1), field),
            bottom: 9 - x - (decks - 1) >= 0 && isCellsArroundAvailable(+cellId + verticalMoving * (decks - 1), field)
        };

        const availableDirections = Object.entries(directions).filter(item => item[1] === true).map(item => item[0]);

        if (availableDirections.length === 0) {
            return createShip(field, decks);
        } else {
            const randomDirection = uniqueRandomArray(availableDirections);
            const ship = coordsGenerator(cellId, randomDirection(), decks);
            ship.forEach(id => field[+id].target = true);
            allShips.push(ship);
            return field;
        }
    }

    const coordsGenerator = (start, direction, decks = 1) => {

        if (decks === 1) {
            return start;
        }

        const ship = Array.apply(null, Array(decks));

        switch (direction) {
            case 'left':
                return ship.map(() => {
                    const cell = start - --decks;
                    return toXY(cell);
                }).reverse();
            case 'top':
                return ship.map(() => {
                    const cell = start - --decks * 10;
                    return toXY(cell);
                }).reverse();
            case 'right':
                return ship.map(() => {
                    const cell = +start + --decks;
                    return toXY(cell);
                }).reverse();
            case 'bottom':
                return ship.map(() => {
                    const cell = +start + --decks * 10;
                    return toXY(cell);
                }).reverse();
            default: throw Error;
        }
    }

    const addShipsToField = (field, decks) => {
        if (decks.length) {
            field = createShip(field, decks[0]);
            decks.shift();
            return addShipsToField(field, decks)
        }
        return field;
    }

    const emptyField = createEmptyField();
    const decks = [4, 3, 3, 2, 2, 2, 1, 1, 1, 1];
    const generatedField = addShipsToField(emptyField, decks);

    return { generatedField, allShips };
}